let token = sessionStorage.getItem("token");
export function _auth(_self, callback) {
    if (ua === "wx") {
        UTILS.getWXConfig(location.href.split("#")[0]);
        wx.ready(function () {
            UTILS.hiddenMenu();
        });
    }
    if (!token) {
        let link = `${window.location}`;
        sessionStorage.link = link;
        //直接重新授权
        const code = UTILS.getAuthCodeFromHref();
        if (UTILS.getQueryString("promoteStr")) {
            localStorage.promoteStr = UTILS.getQueryString("promoteStr");
        }
        if (UTILS.getQueryString("fromChannel")) {
            sessionStorage.fromChannel = UTILS.getQueryString("fromChannel");
        }
        if (UTILS.getQueryString("fromPoint")) {
            sessionStorage.fromPoint = UTILS.getQueryString("fromPoint");
        }
        if (ua === "wx" && !UTILS.getQueryString("openid")) {
            let link = `${window.location}`;
            link = link.split("#")[0];
            location.replace(
                `${API.baseUrl}/wxuser?url=${encodeURIComponent(link)}`
            );
        } else if (!code) {
            UTILS.redirectToGetAuthCode();
        } else {
            _self.toastInst = _self.$toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true, // 禁用背景点击
                loadingType: "spinner",
                message: "登录中..."
            });
            UTILS.getUserInfo(
                code,
                () => {
                    _self.toastInst.clear();
                    callback();
                    _self.token = sessionStorage.getItem("token");
                },
                () => {
                    _self.$toast("获取不到用户信息，请刷新后重试！");
                    setTimeout(() => _self.toastInst.clear(), 3000);
                }
            );
        }
    };
}